import { testimonials } from "@/mocks/manga";

const avatarColors = ["bg-primary-500", "bg-secondary-500", "bg-accent-500", "bg-primary-300"];

export default function ReviewSection() {
  return (
    <section id="review" className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
      <div className="mb-8 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-medium uppercase tracking-widest text-primary-600">
            <i className="ri-chat-3-line"></i> REVIEW
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">读者口碑</h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
            来自火影同人漫画爱好者的真实评价，你的每一次点赞都在帮更多人发现好作品。
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {testimonials.map((t, idx) => (
          <figure key={t.name} className="flex flex-col rounded-lg bg-background-100 p-5 ring-1 ring-background-200/70">
            <div className="flex items-center gap-1 text-secondary-500">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-sm"></i>
              ))}
            </div>
            <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">「{t.text}」</blockquote>
            <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200/70 pt-4">
              <span className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold text-background-50 ${avatarColors[idx] ?? "bg-primary-500"}`}>
                {t.avatar}
              </span>
              <div>
                <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                <div className="text-xs text-foreground-500">{t.role}</div>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}